import {IFeed, FeedType, IActiveFeed} from "./types";
import {createAction, createAsyncAction} from "typesafe-actions";
import {IdObjectsWithId} from "../../utils";
import {IFileData} from "../files/filedata/types";

export const loadFeedsAsyncActions = createAsyncAction(
    'INIT_FEED_STATE_REQUEST',
    'INIT_FEED_STATE_SUCCESS',
    'INIT_FEED_STATE_FAILURE'
)<{}, { feeds: IdObjectsWithId<IFeed>, feedType: FeedType }, { error: Error }>();

export interface IAddFeedToFeedManagerActionPayload {
    feeds: IFeed[];
    feedType: FeedType;
}

export const addFeedToFeedManagerAction = createAction('ADD_FEEDS_TO_FEED_MANAGER', action => {
    return (params: IAddFeedToFeedManagerActionPayload) => action(params);
});

export interface ISaveFeedAsyncRequestPayload {
    feed: IFeed;
    feedType: FeedType;
}

export const saveFeedAsyncActions = createAsyncAction(
    'SAVE_FEED_REQUEST',
    'SAVE_FEED_SUCCESS',
    'SAVE_FEED_FAILURE'
)<ISaveFeedAsyncRequestPayload, { feed: IFeed }, { error: Error }>();


export interface IDeleteFeedActionPayload {
    id: string;
}

export const deleteFeedAsyncActions = createAsyncAction(
    'DELETE_FEED_REQUEST',
    'DELETE_FEED_SUCCESS',
    'DELETE_FEED_FAILURE'
)<IDeleteFeedActionPayload, IDeleteFeedActionPayload, { error: Error }>();

export interface ISelectFeedActionPayload {
    feed: IFeed;
}

export const setActiveFeedAction = createAction('SET_ACTIVE_FEED', action => {
    return (params: ISelectFeedActionPayload) => action(params);
});


export interface IModifyingActiveFeedActionPayload {
    feed: Partial<IActiveFeed>;
}

export const modifyingActiveFeedAction = createAction('MODIFYING_ACTIVE_FEED', action => {
    return (params: IModifyingActiveFeedActionPayload) => action(params);
});